<template>
    <div
        :class="'py-2 px-4 lg:px-10 w-full' + ' ' + wrapperClasses"

    >
        <div class="mx-auto w-auto max-w-[1440px] px-4 lg:px-10">
            <slot  />
        </div>
    </div>
</template>
<script>
export default {
    name: "page-super-banner",
    props: {
      wrapperClasses: {
        type: String,
        default: "bg-primary-default text-white text-center text-[15px] border-b-primary-darker",
      },
    },
};
</script>
